<template>
    <div style="padding:8px 15px 8px;background:#ededed " id="cepingxlc">
        <div class="content">
            <div class="title">
                <img src="/static/qmsj/img/icon1.jpg" alt=""><span class="titletext">基本信息</span>
            </div>
            <div class="evaluation-main">

                <el-row :gutter="0">
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">会员姓名：</span><span class="maianListx">{{baseinfo.baobao_name}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">别名：</span><span class="maianListx">{{baseinfo.baobao_name2}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">月龄：</span><span class="maianListx">{{baseinfo.months}}月</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">性别：</span><span class="maianListx">{{baseinfo.baobao_sex}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">生产方式：</span><span class="maianListx">{{baseinfo.answer1}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">哺乳方式：</span><span class="maianListx">{{baseinfo.answer2}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">爸爸姓名：</span><span class="maianListx">{{baseinfo.answer3}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">职业：</span><span class="maianListx">{{baseinfo.answer4}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">年龄：</span><span class="maianListx">{{baseinfo.answer5}}岁</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">性格：</span><span class="maianListx">{{baseinfo.answer6}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">爸爸在家时间：</span><span class="maianListx">{{baseinfo.answer7}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">与宝宝互动：</span><span class="maianListx">{{baseinfo.answer8}}</span>
                        </div>
                    </el-col>

                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">妈妈姓名：</span><span class="maianListx">{{baseinfo.answer9}}</span>
                        </div>
                    </el-col>

                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">职业：</span><span class="maianListx">{{baseinfo.answer10}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">年龄：</span><span class="maianListx">{{baseinfo.answer11}}岁</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">性格：</span><span class="maianListx">{{baseinfo.answer12}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">妈妈在家时间：</span><span class="maianListx">{{baseinfo.answer13}}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">与宝宝互动：</span><span class="maianListx">{{baseinfo.answer14}}</span>
                        </div>
                    </el-col>

                    <el-col :span="8">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">爬行时间：</span><span class="maianListx">第
                 {{baseinfo.answer15}}个月
                  </span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">走路时间：</span><span class="maianListx">第
                 {{baseinfo.answer16}}个月
                  </span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">辅食添加：</span><span class="maianListx">第
                  {{baseinfo.answer17}} 个月
                  </span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">断奶时间：</span><span class="maianListx">第
                 {{baseinfo.answer18}}个月
                  </span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">开口说话：</span><span class="maianListx">第
                  {{baseinfo.answer19}} 个月
                  </span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="maianList" >
                            <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">会叫人时间：</span><span class="maianListx">第
                {{baseinfo.answer20}} 个月
                  </span>
                        </div>
                    </el-col>

                </el-row>

            </div>

        </div>


        <div class="content" style="margin-top: 10px">
            <div class="title" style="margin-bottom: 20px">
                <img src="/static/qmsj/img/icon2.jpg" alt=""><span class="titletext">宝宝成长测评</span>
            </div>
            <div class="evaluation-main" style="padding-left: 30px">

                <div class="listmsg" style="margin-top: 10px" >
                    <el-row :gutter="0">
                        <el-col :span="24">
                            <div class="maianList text-center"  >宝宝身体信息</div>
                        </el-col>

                        <span v-for="msg1 in leveldata[1]">
                <el-col :span="4"  v-if="msg1.html_type=='计数器'" >
                    <div class="maianList" >
                        <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">{{msg1.question}}：</span><span class="maianListx">{{msg1.answer}}{{msg1.suffix}}</span>
                    </div>
                </el-col>


               <el-col :span="4"  v-if="msg1.html_type=='单选框'" >
                    <div class="maianList" >
                        <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">{{msg1.question}}：</span><span class="maianListx">{{msg1.answer}}</span>
                    </div>
                </el-col>
    <el-col :span="4"  v-if="msg1.html_type=='多选框'" >
                    <div class="maianList" >
                        <img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">{{msg1.question}}：</span><span class="maianListx">{{msg1.answer}}</span>
                    </div>
                </el-col>

                 </span>

                    </el-row>
                </div>

                <div class="listmsg" style="margin-top: 10px" >
                    <el-row :gutter="0">
                        <el-col :span="24">
                            <div class="maianList text-center" >宝宝成长过程中遇到的状况</div>
                        </el-col>

                        <span v-for="amsg in leveldata[2]">
                    <el-col :span="6" v-for="(msg2,msg2index) in amsg.options" :key="msg2index">
                        <div class="maianList" >
                           <span class="maianListCatalog">{{msg2[0]}}</span>
                            <img v-if="msg2[1]==1" class="xuanz" src="/static/qmsj/img/duigouselect.jpg" alt="">
                            <img v-if="msg2[1]==2" class="xuanz" src="/static/qmsj/img/duigouk.jpg" alt="">
                        </div>
                    </el-col>
                    </span>

                    </el-row>
                </div>

                <div class="listmsg" style="margin-top: 10px" >
                    <el-row :gutter="0">
                        <el-col :span="24">
                            <div class="maianList text-center" >教养人及主要教养方式</div>
                        </el-col>
                        <span v-for="amsg2 in leveldata[3]">
                    <el-col :span="24" >
                        <div class="maianList" >
                            <span class="maianListCatalog">{{amsg2.question}}：</span>
                            <span v-for="msg22 in amsg2.options">
                                   <span >{{msg22[0]}}</span><img v-if="msg22[1]==1" class="xuanz" src="/static/qmsj/img/duigouselect.jpg" style="margin-right: 15px" alt=""><img v-if="msg22[1]==2" class="xuanz" src="/static/qmsj/img/duigouk.jpg" style="margin-right: 15px" alt="">
                            </span>

                        </div>
                    </el-col>
                    </span>

                    </el-row>
                </div>


                <div class="listmsg" style="margin-top: 10px" >
                    <el-row :gutter="0">
                        <el-col :span="24">
                            <div class="maianList text-center" >家长教养知识状况</div>
                        </el-col>

                        <span>

                    <span v-for="(amsg4,index) in leveldata[4]" v-if="amsg4">

                        <span   v-if="amsg4.html_type=='单选框'">
                    <el-col :span="20">
                        <div class="maianList" >
                            <span class="maianListCatalog">{{index+1}}、{{amsg4.question}}。</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="maianList"  style="overflow: hidden" >
                            <span v-for="msg4 in amsg4.options" >
                                <span>{{msg4[0]}}</span>
                                <img v-if="msg4[1]==1" class="xuanz" src="/static/qmsj/img/duigouselect.jpg" style="margin-right: 15px" alt="">
                                <img v-if="msg4[1]==2" class="xuanz" src="/static/qmsj/img/duigouk.jpg" style="margin-right: 15px" alt="">
                            </span>
                        </div>
                    </el-col>
                            </span>
                     </span>

                    </span>


                    </el-row>
                </div>

                <div class="huiBtn zi" style="width: 90px;margin: 30px auto" @click="jumper(iid,1,1)">确定</div>

            </div>

        </div>


    </div>
</template>

<script>
export default {

    data() {
        return{
            iid:'',
            baseinfo:'',
            leveldata:'',
            token:''
        }
  },
    methods:{
        jumper:function (iid,num,type) {
            this.$router.push({
                name:'datiyelc',
                query:{
                    iid:iid,
                    num:num,
                    type:type
                }
            })

        }


    },
    mounted:function(){
        this.iid=this.$route.query.iid;
        let self=this;
        self.token = $.cookie('token');
        $.ajax({
            url:process.env.apiUrl + `saas/ceping/cp_query_show`,
            type:"post",
            dataType:"json",
            data:{
                token:self.token,
                cp_list_id:self.iid,

            },
            success:function(data){
                self.baseinfo=data.baseinfo;
                self.leveldata=data.leveldata;
            }
        });

    }



}
</script>
<style scoped>
    [v-cloak] {
        display: none;
    }
    body{
        color: #666;
        font-size: 16px;
    }
    #cepingxlc  .content{
        background: #fff;
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    #cepingxlc .title{
        font-size: 20px;
        line-height: 30px;
        height: 30px;
    }
    #cepingxlc .title img{
        width: 30px;
        height: 30px;
        vertical-align: middle;
    }
    #cepingxlc .titletext{
        padding-left: 20px;
    }
    #cepingxlc .evaluation-main{
        padding-left: 20px;
    }
    #cepingxlc .maianList{
        height: 34px;
        line-height: 34px;
    }
    #cepingxlc  .circle{
        width:10px;
        vertical-align: middle;
    }
    #cepingxlc  .maianListCatalog{
        padding-left: 10px;
    }
    #cepingxlc .maianListx{
        color: #000;
    }
    #cepingxlc .listmsg{
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
        padding:20px 0 20px 20px;
        border-radius:10px ;
    }
    #cepingxlc .xuanz{
        width: 16px;
        margin-left: 5px;
        vertical-align: middle;
        margin-top: -5px;
    }
    #cepingxlc  .huiBtn{
        padding:3px 20px;
        /*border-radius:18px;*/
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        text-align: center;
        font-size: 16px;
    }
    #cepingxlc  .huiBtn.zi{
        background:#E6BE8A;
        color:#fff ;
    }
</style>



// WEBPACK FOOTER //
// src/pages/ceping/cepingxlc.vue